<rav-table
  [config]="tableConfig"
  [dataSource]="dataSource"
  (actionTriggered)="onActionsTriggered($event)"
  headerText="Payment History">
</rav-table>
